<div class="circle-image shadow" [style.backgroundImage]="'url(' + image.current + ')'">
  <input type="file" id="image" accept="image/x-png,image/gif,image/jpeg" (change)="updateImage($event)" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_edit_personnaliser_image"/>
  <div>
    <a class="me-4 cursor-pointer" (click)="deleteImage()"><fa-icon [icon]="faTrash" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_edit_supprimer_image"></fa-icon></a>
    <label for="image"><fa-icon [icon]="faCloudUploadAlt"></fa-icon></label>
  </div>
</div>
